import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-09e02864")
const _hoisted_1 = { class: "pokemon-card" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "pokemon-card__header" }
const _hoisted_4 = { class: "pokemon-card__name" }
const _hoisted_5 = { class: "pokemon-card__number" }
const _hoisted_6 = { class: "pokemon-card__ability" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Ability: ")
const _hoisted_8 = { class: "pokemon-card__ability-name" }
const _hoisted_9 = { class: "pokemon-card__types" }
const _hoisted_10 = ["src", "alt"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      class: "pokemon-card__sprite-container",
      to: { name: 'PokemonDetails', params: { name: _ctx.pokemon.name } }
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          class: "pokemon-card__sprite",
          src: _ctx.pokemon.sprites.front_default,
          alt: _ctx.pokemon.name + ' sprite'
        }, null, 8, _hoisted_2)
      ]),
      _: 1
    }, 8, ["to"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.pokemon.name), 1),
      _createElementVNode("small", _hoisted_5, "#" + _toDisplayString(_ctx.pokemon.id), 1)
    ]),
    _createElementVNode("p", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.pokemon.abilities[0].ability.name), 1)
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pokemon.types, (slot) => {
        return (_openBlock(), _createElementBlock("span", {
          class: _normalizeClass(['app__type-pill', `app__type-pill--${slot.type.name}`]),
          key: slot
        }, [
          _createTextVNode(_toDisplayString(slot.type.name) + " ", 1),
          _createElementVNode("img", {
            class: "app__type-pill-icon",
            src: _ctx.loadTypeImg(slot.type.name),
            alt: `${slot.type.name} icon`
          }, null, 8, _hoisted_10)
        ], 2))
      }), 128))
    ])
  ]))
}